import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";


const PieChart = (props) => {
    return <HighchartsReact highcharts={Highcharts} options={{
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: "pie",
          },
          tooltip: {
            pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
          },
          accessibility: {
            point: {
              valueSuffix: "%",
            },
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: "pointer",
              dataLabels: {
                enabled: false,
              },
              showInLegend: true
            },
          },      
          ...props.options
        }} />;
};

export default PieChart;